<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
  @font-face {
    font-family: 'biomedium';
    src: url('./assets/fonts/Bioplan Grotesk Medium.woff2') format('woff2'),
    url('./assets/fonts/Bioplan Grotesk Medium.woff') format('woff'),
    url('./assets/fonts/Bioplan Grotesk Medium.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: 'bioregular';
    src: url('./assets/fonts/Bioplan Grotesk Regular.woff2') format('woff2'),
    url('./assets/fonts/Bioplan Grotesk Regular.woff') format('woff'),
    url('./assets/fonts/Bioplan Grotesk Regular.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  #app {
    font-family: 'biomedium', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 11pt;
    height: 100%;
  }
  .font-medium {
    font-family: 'biomedium';
  }
  .font-regular {
    font-family: 'bioregular';
  }
  body, html {
    height: 100%;
    margin: 0;
    padding: 0;
    background-color: #414141;
  }
  .information {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 107px;
    background-color: white;
    z-index: 9999;
  }
  .information .signet {
    position: absolute;
    left: 25px;
    top: 25px;
    bottom: 25px;
  }
  .information img.signet {
    width: 72px;
    height: 57px;
  }
  @media (max-width: 700px), (max-height: 400px) {
    .information {
      height: 50px;
      font-size: 10pt;
    }
    .information img.signet {
      width: 36px;
      height: 28px;
      top: 10px;
      left: 25px;
    }
  }
  .menu {
    padding: 0 0 10px 0;
    border-bottom: 1px solid white;
    z-index: 9500;
  }
  .menu ul li {
    margin-bottom: 3px;
  }
  @media (min-width: 600px) and (min-height: 400px) {
    .menu {
      background-color: #414141;
      position: fixed;
      top: 0;
      right: 25px;
      left: 25px;
      padding-top: 25px;
      padding-left: 0;
    }
    .container {
      margin-top: 95px;
    }
  }
  .menu ul {
    padding: 0 0 10px 0;
    margin: 0;
    list-style: none;
  }
  .menu a {
    color: white;
    text-decoration: none;
  }
  .menu a.active {
    text-decoration: none;
    border-bottom: 1px solid white;
  }
  .left a {
    color: white;
    text-decoration: none;
  }
  .left h1 {
    font-size: 11pt !important;
    font-family: 'biomedium' !important;
    font-weight: normal;
  }
  .left h2 {
    font-size: 10pt;
    font-family: 'biomedium' !important;
    font-weight: normal;
  }
  .left h3 {
    font-size: 9pt;
    font-family: 'biomedium' !important;
    font-weight: normal;
  }
  .left {
    font-size: 11pt;
    line-height: 13pt;
  }
</style>



// WEBPACK FOOTER //
// App.vue?078d0684